import { NGS } from "../../../utils/constants";

export const WorkFlowDefaultData = {
    id: '',
    workflowName: NGS,
    sampleIDs: [],
    status: 0, 
    draftSamples: '',
    samples: '',
    removedSamples: ''
  }